module.exports = __webpack_public_path__ + "static/media/credit-card-refresh-svgrepo-com.9be2e07a.svg";